import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTES } from '../../data/constants'
import { useAIRiskReportExportMode } from '../RenderMode/AIRiskReportRenderModeProvider'
import styles from './SubArea.module.scss'

export default function SubArea({
  titleId,
  detailId = undefined,
  detailValues = undefined,
  descriptionId = undefined,
  hideFromExport = false,
  children,
}) {
  const isExportMode = useAIRiskReportExportMode()

  if (isExportMode && hideFromExport) return null

  return (
    <div className={styles.area}>
      <div className={styles.header} {...AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTES}>
        <h3 className={styles.title}>
          <FormattedMessage id={titleId} />
        </h3>
        {detailId && (
          <div className={styles.description}>
            <FormattedMessage id={detailId} values={detailValues} />
          </div>
        )}
        {descriptionId && (
          <div className={styles.description}>
            <FormattedMessage id={descriptionId} />
          </div>
        )}
      </div>
      {children}
    </div>
  )
}

SubArea.propTypes = {
  titleId: PropTypes.string.isRequired,
  detailId: PropTypes.string,
  detailValues: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  descriptionId: PropTypes.string,
  hideFromExport: PropTypes.bool,
  children: PropTypes.node.isRequired,
}
